
export default [
  {
    path: '/',
    name: 'main',
    redirect: '/home',
    component: () => import('views/main.vue'),
    children: [
      {
        path: '/home',
        name: 'home',
        component:  () => import('views/home/home.vue'),
      },
      {
        path: '/classify',
        name: 'classify',
        component: () => import('views/goods-classify/goodsClassify.vue'),
        meta: {
          keepAlive: false,
        },
      },
      {
        path: '/shop-cart',
        name: 'shopCart',
        component: () => import('views/shop-cart/shop-cart'),
        meta: {
          needToken: true,
        },
      },
      {
        path: '/mine',
        name: 'mine',
        component:() => import('views/mine/mine'),
        meta: {
          needToken: true,
        },
      },
    ],
  },
  {
    path: '/goods-list',
    name: 'goodsList',
    component: () => import('views/goods-list/goodsList.vue'),
    meta: {
      keepAlive: false,
    },
  },
  {
    path: '/goods-detail',
    name: 'goodsDetail',
    component: () => import('views/goods-detail/goods-detail.vue'),
  },
  {
    path: '/settle',
    name: 'settle',
    component: () => import('views/settle/settle'),
  },
  {
    path: '/generate-settle',
    name: 'generateSettle',
    component: () => import('views/settle/generate-settle'),
    meta: {
      needToken: true,
    },
  },
  {
    path: '/address',
    name: 'address',
    component: () => import('views/address/address-select'),
    meta: {
      needToken: true,
    },
  },
  {
    path: '/add-address',
    name: 'addAddress',
    component: () => import('views/address/add-address'),
    meta: {
      needToken: true,
    },
  },
  {
    path: '/order-success',
    name: 'orderSuccess',
    component: () => import('views/settle/order-over'),
    meta: {
      needToken: true,
    },
  },
  {
    path:'/evaluate-list',
    name: 'evaluateList',
    component: () => import('views/evaluate/evaluate-list'),
  }
];
